module.exports = __webpack_public_path__ + "assets/img/right_5.757d789b.png";